export default "__VITE_PUBLIC_ASSET__74becfb8__"